import { enqueueSnackbar } from "./snackbarUtils";
import i18n from "i18next";

export const handleError = (error: any) => {
  try {
    // Check if it's an Axios error with a status code
    if (error?.response?.status) {
      const status = error.response.status;
      const messages = error?.response?.data?.message;
      
      // If backend provided a message, use it
      if (messages) {
        const isArray = Array.isArray(messages);
        if (isArray) {
          for (let message of messages) {
            const prefixedMessage = `errorMessages.${message}`;
            const translatedMessage = i18n.exists(prefixedMessage) ? i18n.t(prefixedMessage) : message;
            enqueueSnackbar(translatedMessage, {
              variant: "error",
            });
          }
        } else {
          const prefixedMessage = `errorMessages.${messages}`;
          const translatedMessage = i18n.exists(prefixedMessage) ? i18n.t(prefixedMessage) : messages;
          enqueueSnackbar(translatedMessage, {
            variant: "error",
          });
        }
        return;
      }
      
      // Otherwise, show a generic error based on status code
      let errorKey = 'general.error';
      if (status === 500) {
        errorKey = 'errorMessages.error.internal_server_error';
      } else if (status === 404) {
        errorKey = 'errorMessages.error.not_found';
      } else if (status === 401 || status === 403) {
        errorKey = 'errorMessages.error.unauthorized';
      }
      
      const translatedMessage = i18n.exists(errorKey) ? i18n.t(errorKey) : i18n.t('general.error');
      enqueueSnackbar(translatedMessage, {
        variant: "error",
      });
      return;
    }
    
    // Handle other error types (network errors, etc.)
    const messages = error?.message;
    if (messages) {
      const prefixedMessage = `errorMessages.${messages}`;
      const translatedMessage = i18n.exists(prefixedMessage) ? i18n.t(prefixedMessage) : i18n.t('general.error');
      enqueueSnackbar(translatedMessage, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(i18n.t('general.error'), {
        variant: "error",
      });
    }
  } catch (e) {
    // Never let the error reporter itself throw - it runs inside .catch()
    // handlers and an exception here would escape to the ErrorBoundary.
    console.error(e);
    try {
      enqueueSnackbar(i18n.t('general.error'), {
        variant: "error",
      });
    } catch (inner) {
      console.error(inner);
    }
  }
};
